// 1. Import the React and ReactDOM libraries
// 2. Get a reference to the div with ID root
// 3. Tell React to take control of that element
// 4. Create a react component
// 5. Take the react component and show it on the screen
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import AOS from "aos";
import "./styles/bootstrap.min.css";
import "./styles/aos.css";
import "./styles/swiper-bundle.min.css";
import "./styles/style.css";
import "./styles/quantum.css";
import "./styles/globals.css";

AOS.init();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
